module.exports = __webpack_public_path__ + "img/order-sent.b6c2eeb4.jpg";